import React from "react";
import { Link } from "react-router-dom";
import useSEO from "../hooks/useSEO";

const NotFound = () => {
  useSEO({
    title: "Page not found",
    description: "The page you're looking for doesn't exist.",
    noindex: true,
  });

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16">
      <div className="text-center max-w-md animate-fade-up">
        {/* Broken-equalizer illustration */}
        <div
          className="mx-auto mb-8 w-20 h-20 rounded-2xl bg-ink-900 flex items-end justify-center gap-[5px] pb-5 pt-5 px-5"
          aria-hidden="true"
        >
          {[0.5, 0.9, 0.3, 0.7].map((h, i) => (
            <span
              key={i}
              className="w-[5px] rounded-full bg-white/40"
              style={{ height: `${h * 100}%` }}
            />
          ))}
        </div>

        <p className="text-sm font-semibold uppercase tracking-wider text-blue-600 mb-3">
          404 — Page not found
        </p>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-ink-900 mb-4">
          This page is off the air
        </h1>
        <p className="text-slate-500 leading-relaxed mb-8">
          The page you're looking for doesn't exist or may have been moved. The
          episodes are still playing on the home page.
        </p>

        <div className="flex items-center justify-center gap-3 flex-wrap">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold transition-colors duration-200"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z" />
            </svg>
            Browse episodes
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center px-6 py-3 rounded-lg border border-slate-200 bg-white text-ink-900 text-sm font-semibold hover:border-blue-300 hover:text-blue-600 transition-colors duration-200"
          >
            About this project
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
